<template lang="pug">
    v-card(outlined)
        v-system-bar(height="50")
            v-spacer
            v-btn(icon outlined small @click="addNewTest()")
                v-icon.mr-0 mdi-plus

        v-card-text
            v-progress-linear(v-if="loading" :indeterminate="true")
            v-row(v-else)
                v-col(cols="12" sm="12" md="4" lg="3"  v-for="test in tests" :key="test.id")
                    v-card(outlined)
                        v-system-bar(height="50") {{ $showLocalizedField(test.name, locale).text }}
                            v-spacer
                            v-btn.ml-1(outlined icon small @click="editExistTest(test)")
                                v-icon.mr-0 mdi-pencil
                            //v-btn.ml-1(outlined icon small @click="showDelTestDialog(test)") 
                                v-icon.mr-0 mdi-delete
                        v-card-text Количество заданий - {{ test.questionCount }} 
                            router-link(:to="'/admin/tests/'+test.id") Редактировать задания





        v-dialog(v-model="testDialog" max-width="900" scrollable)
            v-card(v-if="editTest") 
                v-card-title(style="background:#e0e0e0;") {{ $showLocalizedField(editTest.name, locale).text }}
                    v-spacer
                    v-btn.ml-1(outlined icon small @click="closeTestDialog()")
                         v-icon.mr-0 mdi-close

                v-card-text 
                    v-form(v-on:submit.prevent="onSubmit")

                        v-card.mb-7(outlined)
                            v-card-title  Локализованое поле Название
                            v-card-text
                                v-text-field(v-for="(name,index) in editTest.name" :key="index" v-model="name.text" :label="'Название ('+name.locale+')'" @input="name.validate(index)" @blur="name.validate(index)" :error-messages="name.errors" outlined)
                                    v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField('name',index)")
                                        v-icon mdi-close
                                v-menu(v-if="availableFieldLocales('name').length > 0" open-on-hover)
                                    template(v-slot:activator="{ on }")
                                        v-btn(v-on="on") Добавить локализацию
                                    v-card
                                        v-list-item(v-for="item in availableFieldLocales('name')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('name',item)")

                    

                        v-card.mb-7(outlined) 
                            v-card-text 
                                .mb-3 Локализованое поле описание
                                v-textarea(v-for="(discription,index) in editTest.discription" :key="index" v-model="discription.text" :label="'Описание ('+discription.locale+')'" @input="discription.validate(index)" @blur="discription.validate(index)" :error-messages="discription.errors" outlined required)
                                    v-btn(v-if="index>0" slot="append" icon outlined small @click="removeLocalizedField('discription',index)") 
                                        v-icon mdi-close
                                v-menu(v-if="availableFieldLocales('discription').length > 0" open-on-hover)
                                    template(v-slot:activator="{ on }")
                                        v-btn(v-on="on") Добавить локализацию
                                    v-card
                                        v-list-item(v-for="item in availableFieldLocales('discription')" :key="item.value" v-text="item.text[locale]" @click="addLocalizedField('discription',item)")

                        v-card-actions
                            v-btn(type="submit") Сохранить

</template>

<script>
    import { mapState } from "vuex";

    import { testsService } from '@/_services'

    export default {
        name:'testlist',

        mounted () {
            this.loadTestsList()
        },

        computed: {
            ...mapState(['locale','locales']),

            defaultLocale(){
                return this.locales.filter(f => f.default == true)[0]
            }
        },

        methods: {
            loadTestsList(){
                testsService.loadTestsList().then(data=>{
                    this.tests = data
                })
            },
            showTestDialog(){
                this.testDialog = true
            },
            closeTestDialog(){
                this.testDialog = false
            },
            showDelTestDialog(test){
                this.editTest = test
            },
            addNewTest(){
                this.editTest = {
                    name:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новый тест'
                        }
                    ],
                    discription:[
                        {
                            locale:this.defaultLocale.value,
                            text:'Новый тест'
                        }
                    ]
                }

                this.assignFieldsFunctions()
                this.showTestDialog()
            },

            editExistTest(test){
                this.editTest = test
                this.assignFieldsFunctions()
                this.showTestDialog()
            },

            availableFieldLocales(field){
                let locs = this.locales.filter(loc=>{
                    let dflt = !this.editTest[field].some(f => f.locale == loc.value)
                    return dflt
                })
                return locs
            },

            assignFieldsFunctions(){
                this.editTest.name.map(el => {this.addFunction('name',el)})
                this.editTest.discription.map(el => {this.addFunction('discription',el)})
            },

            addFunction(fieldName, field){
                let _self = this.editTest
                this.$set(field,'errors',[])
                this.$set(field,'validate',function(index){
                    let err = []

                    if (_self[fieldName][index].text.trim() == '') {
                        err.push('Обязательное поле')
                    }
                    field.errors = err
                })
                return field
            },

            addLocalizedField(field,locale){
                let exist = this.editTest[field].some(f => f.locale == locale.value)
                if (!exist){
                    let defaultField = this.editTest[field][0]

                    let newField = {}
                    this.$set(newField,'locale',locale.value)
                    this.$set(newField,'text',defaultField.text)

                    this.addFunction(field,newField)
                    this.editTest[field].push(newField)
                }
            },

            removeLocalizedField(field,fieldIndex){
                this.editTest[field].splice(fieldIndex, 1)
            },

            validate(){
                let hasErrors = false;
                if (!hasErrors) hasErrors = this.editTest.name.some(t => t.errors.length > 0)
                if (!hasErrors) hasErrors = this.editTest.discription.some(t => t.errors.length > 0)
                return hasErrors
            },

            onSubmit(){
                if (!this.validate()){
                    this.$nextTick(() => {
                        testsService.saveTest(this.editTest).then(data=>{
                            this.loadTestsList()
                            this.testDialog = false
                            this.editTest = null
                        })
                    })
                }
            }
        },

        data() {
            return {
                loading:false,
                tests:[],

                testDialog:false,
                editTest:null
            }
        }
    }
</script>